import { render, staticRenderFns } from "./SavingsPage.vue?vue&type=template&id=1946ee28&scoped=true"
import script from "./SavingsPage.vue?vue&type=script&lang=js"
export * from "./SavingsPage.vue?vue&type=script&lang=js"
import style0 from "./SavingsPage.vue?vue&type=style&index=0&id=1946ee28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1946ee28",
  null
  
)

export default component.exports